const TOGGLE_SCROLL_TO_REF = 'TOGGLE_SCROLL_TO_REF';

export default TOGGLE_SCROLL_TO_REF;
